/**
 * Правило «кабинет главнее» (14.10.2026): данные рождения из личного
 * кабинета подставляются во все программы, если они заполнены, — прошлый
 * ввод в браузере их не перебивает. Формы программ: profileApplied
 * стартует false (useChartProgram, «Партнёр», «Деньги», «Образ»,
 * «Нумерология», АстроЧакры). Главная — здесь.
 */
/** Карта вкладки посчитана по данным кабинета: та же дата, то же время
 *  (или «не знаю» у обоих), то же место (до сотых градуса). */
export function sessionChartMatchesCabinet(p, user) {
  if (!p || !user) return false;
  const pad = (v) => String(v).padStart(2, '0');
  const date = `${p.year}-${pad(p.month)}-${pad(p.day)}`;
  if (date !== String(user.birth_date || '').slice(0, 10)) return false;
  const unknown = !!user.birth_time_unknown;
  if (unknown !== !!p.time_unknown) return false;
  if (!unknown && String(p.time || '').slice(0, 5) !== String(user.birth_time || '').slice(0, 5)) return false;
  const near = (a, b) => Math.abs(Number(a) - Number(b)) < 0.01;
  return near(p.latitude, user.birth_lat) && near(p.longitude, user.birth_lon);
}

